import React from 'react';
import { StyledPipeSymbol } from '../StyledComponents';

export const StyledPipe = () => <StyledPipeSymbol>|</StyledPipeSymbol>;
